<script>
  export let value = 0;
  export let max = 100;
  export let height = 4;
  export let radius = 0.4;
  export let bgColor = '#896BD9';
  export let animate = true;

  let previousValue = value;
  let animatedValue = animate ? 0 : value;
  let mounted = false;

  // Handle initial animation
  import { onMount } from 'svelte';
  onMount(() => {
    mounted = true;
    if (animate) {
      setTimeout(() => {
        animatedValue = value;
      }, 500);
    }
  });

  // Handle subsequent value changes
  $: {
    if (value !== previousValue && mounted) {
      previousValue = value;
      animatedValue = value;
    }
  }

  $: progress = (animatedValue / max) * 100;
  $: progressStyle = `transform: scaleX(${progress / 100})`;
  $: barHeight = `${height}px`;
  $: borderRadius = `${radius * height}px`;
</script>

<style>
  .progress-bar-container {
    width: 100%;
    background-color: rgba(137, 107, 217, 0.1);
    overflow: hidden;
    position: relative;
  }

  .progress-bar {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 100%;
    background-color: var(--progress-color);
    transform-origin: left;
    transform: scaleX(0);
    will-change: transform;
  }

  .animated {
    transition: transform 1s cubic-bezier(0.4, 0, 0.1, 1);
  }
</style>

<div 
  class="progress-bar-container"
  style="height: {barHeight}; border-radius: {borderRadius};"
>
  <div 
    class="progress-bar"
    class:animated={animate}
    style="--progress-color: {bgColor}; {progressStyle}; border-radius: {borderRadius};"
  />
</div>
